import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";
import { useSelector } from "react-redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Themes from "./themes/index";
import App from "./components/App";
// import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { persistor, store } from "./store/config-store";
import { Scrollbars } from 'react-custom-scrollbars';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as Icons from '@fortawesome/free-solid-svg-icons';
const RootComponent = () => {
  const  currentTheme  = 'axa';//useSelector((state) => state.config.themeConfig);
  const setCurrentTheme = () => {
    if (currentTheme === "light") return Themes.default;
    else if (currentTheme === "dark") return Themes.dark;
    else if (currentTheme === "simpleX") return Themes.simpleX;
    else return Themes.axa;
  };

  const toastStyle = {
    background: "#323232", 
    color: "#fff", 
    textAlign: "center", 
    minHeight: "50px", 
    marginBottom: "2em",
    textTransform: "capitalize",
  }
  const iconList = Object
  .keys(Icons)
  .filter(key => key !== "fas" && key !== "prefix" )
  .map(icon => Icons[icon])

  library.add(...iconList)

  return (
    <Scrollbars autoHide={true} style={{height:"100vh"}}>
    <LayoutProvider>
      <UserProvider>
        <ThemeProvider theme={setCurrentTheme()}>
          <CssBaseline />
          
          <App />
          
        </ThemeProvider>
      </UserProvider>
      <ToastContainer
        closeButton={false}
        autoClose={3000}
        hideProgressBar={true}
        position={"bottom-left"}
        toastStyle={toastStyle}
      />
    </LayoutProvider>
  
    </Scrollbars>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <RootComponent />
    </PersistGate>
  </Provider>,
  document.getElementById("root"),
);
